// components/PreEmployment/PreEmploymentSelection.tsx

import React from "react";
import { usePreEmployment } from "../../hooks/usePreEmployment";
import LoadingSpinner from "../../components/common/LoadingScreen";
import SelectionView from "../../components/consultation/CertificatMedicalComponents/SelectionView";
import CertificateView from "../../components/consultation/CertificatMedicalComponents/CertificateView";



const PreEmploymentSelection: React.FC = () => {
  const {
    selectedStatus,
    showCertificate,
    userLoading,
    constanteData,
    statusOptions,
    handleStatusSelect,
    handleGenerateCertificate,
    handleBack,
    handleBackFromCertificate,
    handleReturnToDashboard,
  } = usePreEmployment();

  // Si les données utilisateur sont en cours de chargement
  if (userLoading) {
    return <LoadingSpinner message="Chargement des données utilisateur..." role={"doctor"} />;
  }

  // Affichage conditionnel
  if (showCertificate) {
    return (
      <CertificateView
        constanteData={constanteData}
        selectedStatus={selectedStatus}
        onBack={handleBackFromCertificate}
        onReturnToDashboard={handleReturnToDashboard}
      />
    );
  }

  return (
    <SelectionView
      constanteData={constanteData}
      statusOptions={statusOptions}
      selectedStatus={selectedStatus}
      onStatusSelect={handleStatusSelect}
      onGenerateCertificate={handleGenerateCertificate}
      onBack={handleBack}
    />
  );
};

export default PreEmploymentSelection;